import React, { act, useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getUserById, getUserByRef } from "../../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../../models/OrgFunctions.js";
import Row from "../../layout/Row.js";
import Column from "../../layout/Column.js";
import Space from "../../layout/Space.js";
import Icon1 from "../../icons/Icon.js";
import MLTFGPT2 from "../../textfields/MLTFGPT2.js";
import DropDown1 from "../../dropdowns/DropDown1.js";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import modifyMaster from "../../api/modify/modifyMaster.js";
import InconButton from "../../buttons/IconButton.js";
import sendInvite from "../../api/send/sendInvite.js";
import { flutterColorToHex } from "../../config/theme.js";
import MemberModal from "../../modals/MemberModal.js";
import Modal1 from "../../modals/Modal1.js";
import MemberColorModal from "../../modals/MemberColorModal.js";
import { useAppContext } from "../../config/AppContext.js";
import createNewMember from "../../api/create/createNewMember.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions.js";
import { Switch } from "@mui/material";
import TextField2 from "../../textfields/TextField2.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";

import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import Tippy from "@tippyjs/react";
import uploadImage from "../../api/upload/uploadImage.js";
import DropDownGPT1X from "../../dropdowns/DropDownGPT1X.js";
import { set } from "date-fns";
import {
  EasySwitch,
  SaveBar,
  ToggleSettingsBrick,
} from "../../textfields/EasySwitch.js";
import TextField2T from "../../textfields/TextField2T.js";
import DropDownGPT03 from "../../dropdowns/DropDownGTP03.js";
import TabGPT from "../../tabs/TabGPT.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import Dropzone3 from "../../dropzones/DropZone3.js";
import DropzoneImage from "../../dropzones/DropZoneImage.js";
import uploadDropZoneTemporary from "../../api/upload/uploadDropZoneTemporary.js";
import sendOrgSignature from "../../api/sign/sendOrgSignature.js";
import { memberRoles } from "../../members/MemberManager.js";
import { checkAndSendTriggerEvent } from "../../config/TriggerEmailSystem.js";

export function getRoleString(role) {
  switch (role) {
    case "admin":
      return "Administrateur";
    case "operator":
      return "Opérateur";
    case "conductor":
      return "Conducteur de travaux";
    case "respo":
      return "Responsable";
    case "commercial":
      return "Commercial";
    case "owner":
      return "Gérant (pas opérationnel)";
    case "secretary":
      return "Assistant(e) technique";
    case "drawer":
      return "Dessinateur-Métreur";
    case "comptable":
      return "Comptable";
    case "project_manager":
      return "Chargé de projet";
    case "architect":
      return "Architecte";
    default:
      return "Inconnu";
  }
}

const intToHexColor = (colorint) => {
  // Extract ARGB components
  const alpha = (colorint >> 24) & 0xff;
  const red = (colorint >> 16) & 0xff;
  const green = (colorint >> 8) & 0xff;
  const indigo = colorint & 0xff;

  // Convert each component to a 2-digit hex value and combine them
  return `#${[red, green, indigo].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
};

const Organisation = ({
  userData,
  orgData,
  navigateWorkspace,
  refreshFolders,
  workspaceData,
}) => {
  const { currentUser, loading } = useAuth();

  // get the tab parameter from the URL
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const { enqueueSnackbar } = useSnackbar();
  const [infos, setInfos] = useState({});

  const [users, setUsers] = useState([]);
  const [signatures, setSignatures] = useState([]);
  const [tampons, setTampons] = useState([]);

  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [tabs, setTabs] = useState([
    {
      id: "infos",
      label: "Informations",
    },
    {
      id: "members",
      label: "Membres",
    },

    {
      id: "signatures",
      label: "Signatures",
    },

    {
      id: "marques",
      label: "Marques",
    },
    orgData.facturation?.plan !== "free"
      ? {
          id: "notifications",
          label: "Notifications",
        }
      : null,

    orgData.facturation?.plan !== "free"
      ? {
          id: "sync_emails",
          label: "Sync Emails",
        }
      : null,

    {
      id: "access",
      label: "Accès",
    },
  ]);
  const [activeTab, setActiveTab] = useState(tab ? tab : "infos");
  const [name, setName] = useState("");
  const [userType, setUserType] = useState(null);
  const [marqueOpen, setMarqueOpen] = useState(false);
  const [loadingMarque, setLoadingMarque] = useState(false);

  const [restrictions, setRestrictions] = useState(null);
  const [notifications, setNotifications] = useState(null);
  const [marques, setMarques] = useState([]);
  const [marque, setMarque] = useState("");
  const [addMarque, setAddMarque] = useState(false);
  const [bigPhoto, setBigPhoto] = useState(null);
  const [signatureName, setSignatureName] = useState("");
  const [newSignatureOpen, setNewSignatureOpen] = useState(false);
  const [newTamponOpen, setNewTamponOpen] = useState(false);

  const [new_email, setNewEmail] = useState("");
  const [syncEmails, setSyncEmails] = useState([]);
  const [newSyncEmail, setNewSyncEmail] = useState("");

  const handleAddMarque = async (index) => {
    setLoadingMarque(true);
    if (index === true) {
      let marques = orgData.marques || [];
      marques.push({ name: marque, tampon_url: "", signature_url: "" });
      await updateDocDataFieldApi(orgData.ref, "marques", marques, prefix);
      handleClickVariant("Marque ajoutée", "success");
      handleFetchData();
    } else {
      let real_index = index - 1;
      let old_marque = orgData.marques[real_index];
      let new_marque = { ...old_marque, name: marque };
      let marques = orgData.marques || [];
      marques[real_index] = new_marque;

      await updateDocDataFieldApi(orgData.ref, "marques", marques, prefix);
      handleClickVariant("Marque modifiée", "success");

      let filters = [
        {
          field: "client_id",
          operator: "==",
          value: orgData.id,
        },
        {
          field: "marque",
          operator: "==",
          value: old_marque.name,
        },
      ];
      let affected_folders = await queryCollection("folder", filters);
      await Promise.all(
        affected_folders.map((folder) =>
          updateDocDataFieldApi(folder.ref, "marque", marque, prefix)
        )
      );
      handleClickVariant("Dossier(s) modifié(s)", "success");
      // wait for 1 second

      // doing this to trigger the saved date update
      if (affected_folders.length > 0) {
        await updateDocDataFieldApi(
          affected_folders[0].ref,
          "marque",
          old_marque.name,
          prefix
        );

        refreshFolders();
        await updateDocDataFieldApi(
          affected_folders[0].ref,
          "marque",
          marque,
          prefix
        );
      }
      await handleFetchData();
    }
    setMarqueOpen(false);
    setLoadingMarque(false);
  };

  const handleCreateSignature = async (istampon = false) => {
    const token = await getOrRefreshFirebaseToken();
    await sendOrgSignature(
      dropped_files[0],
      signatureName,
      orgData.id,
      istampon,
      token,
      prefix
    );
    if (istampon) {
      handleClickVariant("Tampon ajouté", "success");
    } else {
      handleClickVariant("Signature ajoutée", "success");
    }
    setNewTamponOpen(false);

    setNewSignatureOpen(false);
    setSignatureName("");
  };

  const onDelete = (file) => {
    setDroppedFiles((prevFiles) => prevFiles.filter((f) => f !== file));
    if (dropped_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const handleSaveNotifications = async () => {
    try {
      await updateDocDataFieldApi(
        orgData.ref,
        "notifications",
        notifications,
        prefix
      );
      handleClickVariant("Notifications enregistrées", "success");
    } catch (error) {
      handleClickVariant(
        "Erreur lors de l'enregistrement des notifications",
        "error"
      );
      console.error(error);
    }
  };

  const handleRemoveMarque = async (marque) => {
    // check if more than one marque
    let marques = orgData.marques || [];

    if (marques.length === 1) {
      handleClickVariant("Impossible d'avoir moins d'une marque", "error");
      return;
    }
    marques = marques.filter((m) => m.name !== marque);
    await updateDocDataFieldApi(orgData.ref, "marques", marques, prefix);
    handleClickVariant("Marque retirée", "success");
    handleFetchData();
  };

  // Fonction pour afficher les messages Snackbar
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Fonction pour récupérer les données de l'organisation
  const handleFetchData = async () => {
    if (orgData) {
      try {
        let infoss = orgData.infos || {};
        infoss.entreprise = orgData.name;
        setInfos(infoss);
        setRestrictions(orgData.restrictions);
        setNotifications(orgData.notifications);
        setSignatures(orgData.config?.signatures || []);
        setTampons(orgData.config?.tampons || []);
        setMarques(orgData.marques || []);
        setSyncEmails(orgData.sync_emails || []);

        const users = await queryCollection("user", [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ]);
        setUsers(users); // Initialise les employés de l'organisation
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };
  const [dropped_files, setDroppedFiles] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);
  const [droppedExists, setDroppedExists] = useState(false);

  const onDropZone = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  useEffect(() => {
    handleFetchData(); // Récupère les données de l'organisation lorsque le composant est monté
  }, [orgData]);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;
  // Function to update the organization
  const callModifyMaster = async () => {
    if (!orgData) return; // Ensure orgData is available

    try {
      // Get the user's Firebase authentication token
      const token = await currentUser.getIdToken(); // Fetch token from Firebase

      // Prepare the data to be sent for updating the organization
      // Call the API to modify the organization

      await updateDocDataFieldApi(orgData.ref, "infos", infos, prefix);
      await updateDocDataFieldApi(
        orgData.ref,
        "name",
        infos.entreprise,
        prefix
      );
      handleClickVariant("Organisation modifiée avec succès", "success");
      navigateWorkspace("/organisation"); // Navigate to the organizations page
    } catch (error) {
      handleClickVariant(
        "Erreur lors de la modification de l'organisation",
        "error"
      );
      console.error(error);
    }
  };

  const handleSaveRestrictions = async () => {
    try {
      await updateDocDataFieldApi(
        orgData.ref,
        "restrictions",
        restrictions,
        prefix
      );
      handleClickVariant("Restrictions enregistrées", "success");
    } catch (error) {
      handleClickVariant(
        "Erreur lors de l'enregistrement des restrictions",
        "error"
      );
      console.error(error);
    }
  };
  const [loadingAddMember, setLoadingAddMember] = useState(false);
  const callSendInvite = async (already) => {
    setLoadingAddMember(true);
    if (!already && (!email || !name || !userType)) {
      handleClickVariant("Veuillez remplir tous les champs", "error");
      return;
    }

    let email_to_use = already ? email2 : email;

    const filters = [
      {
        field: "email",
        operator: "==",
        value: email_to_use.trim(),
      },
    ];
    const doublons = await queryCollection("user", filters);
    if (doublons.length > 0) {
      if (already) {
        handleClickVariant(
          "Cet utilisateur est déjà enregistré dans l'organisation",
          "error"
        );

        return;
      } else {
        handleClickVariant("Cet email est déjà utilisé", "error");
        return;
      }
    } else {
      if (already) {
        handleClickVariant("Cet email n'est pas enregistré", "error");
        return;
      }
    }

    try {
      const token = await currentUser.getIdToken(); // Fetch token from Firebase
      await createNewMember(
        orgData.id,
        email_to_use.trim(),
        name.trim(),
        userType,
        false,
        token,
        prefix
      ); // Call the sendInvite API
      let org = await getOrgById(orgData.id);
      let users = await getArrayDocDataByID("user", org.users_id);
      let new_user = users.find((user) => user.email === email_to_use);
      await sendInvite(
        new_user.id,
        org.name,
        new_user.email,
        org.id,
        token,
        prefix
      ); // Call the sendInvite API
      await checkAndSendTriggerEvent(
        ["first_member_invited"],
        orgData,
        userData,
        prefix
      );
      handleClickVariant("Invitation envoyée avec succès", "success");
      setEmail("");
      setName("");
      setUserType(null);
      setAddMember(false);
    } catch (error) {
      handleClickVariant("Erreur lors de l'envoi de l'invitation", "error");
      console.error(error);
    }
    setLoadingAddMember(false);
  };
  const handleChangeLogo = async () => {
    const token = await getOrRefreshFirebaseToken();
    await uploadImage(orgData.id, token, prefix);
    handleClickVariant("Logo modifié avec succès", "success");
    // I want the whole app to refresh
  };

  const handleDeleteTampon = async (tampon) => {
    let new_tampons = tampons.filter((t) => t.name !== tampon.name);
    await updateDocDataFieldApi(
      orgData.ref,
      "config.tampons",
      new_tampons,
      prefix
    );
    handleClickVariant("Tampon supprimé", "success");
  };
  const handleDeleteSignature = async (signature) => {
    let new_signatures = signatures.filter((t) => t.name !== signature.name);
    await updateDocDataFieldApi(
      orgData.ref,
      "config.signatures",
      new_signatures,
      prefix
    );
    handleClickVariant("Signature supprimée", "success");
  };

  const handleAddSyncEmail = async () => {
    if (!newSyncEmail || !newSyncEmail.includes("@")) {
      handleClickVariant("Veuillez entrer un email valide", "error");
      return;
    }

    if (syncEmails.includes(newSyncEmail)) {
      handleClickVariant("Cet email est déjà dans la liste", "error");
      return;
    }

    const updatedEmails = [...syncEmails, newSyncEmail];
    setSyncEmails(updatedEmails);

    try {
      await updateDocDataFieldApi(
        orgData.ref,
        "sync_emails",
        updatedEmails,
        prefix
      );
      handleClickVariant("Email ajouté avec succès", "success");
      setNewSyncEmail("");
    } catch (error) {
      handleClickVariant("Erreur lors de l'ajout de l'email", "error");
      console.error(error);
    }
  };

  const handleRemoveSyncEmail = async (emailToRemove) => {
    const updatedEmails = syncEmails.filter((email) => email !== emailToRemove);
    setSyncEmails(updatedEmails);

    try {
      await updateDocDataFieldApi(
        orgData.ref,
        "sync_emails",
        updatedEmails,
        prefix
      );
      handleClickVariant("Email supprimé avec succès", "success");
    } catch (error) {
      handleClickVariant("Erreur lors de la suppression de l'email", "error");
      console.error(error);
    }
  };

  const handleMemberClick = async (user_id, isinfos) => {
    const user = await getUserById(user_id);
    setMemberData(user);
    if (isinfos) {
      setMemberOpen(true);
    } else {
      setMemberColorOpen(true);
    }
  };

  const [memberData, setMemberData] = useState(null);
  const [addMember, setAddMember] = useState(false);
  const [memberOpen, setMemberOpen] = useState(false);
  const [memberColorOpen, setMemberColorOpen] = useState(false);

  if (loading || !currentUser) {
    return <div></div>; // Affiche un message de chargement
  }

  return (
    <div className="w-full h-full overflow-auto flex flex-col ">
      <div className="w-full h-fit flex flex-col items-start justify-start ">
        <Modal1 isOpen={memberOpen} onClose={() => setMemberOpen(false)}>
          <MemberModal
            onClose={() => setMemberOpen(false)}
            user_id={memberData?.id}
            onUpdate={handleFetchData}
            orgData={orgData}
          />
        </Modal1>
        <Modal1
          isOpen={memberColorOpen}
          onClose={() => setMemberColorOpen(false)}
        >
          <MemberColorModal
            onClose={() => setMemberColorOpen(false)}
            user_id={memberData?.id}
            onUpdate={handleFetchData}
          />
        </Modal1>
        <Modal1 isOpen={addMember} onClose={() => setAddMember(false)}>
          <div className="flex flex-col w-c400  h-fit items-center justify-start bg-white rounded-xl">
            <div className="text-h2 w-full font-medium text-left p-4 border-b-1">
              Ajouter un nouveau membre
            </div>
            <div className="flex flex-col w-full gap-2  bg-neutral-50 p-4">
              <TextField2T
                className="w-full text-left"
                label="Email"
                value={email}
                type="email"
                transparent={false}
                mandatory={true}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField2T
                className="w-full text-left"
                label="Prénom nom"
                value={name}
                transparent={false}
                mandatory={true}
                onChange={(e) => setName(e.target.value)}
              />

              <div className="flex flexol gap-2">
                <DropDownGPT03
                  label="Type d'utilisateur"
                  value={userType}
                  mandatory={true}
                  className={"w-full"}
                  transparent={false}
                  onChange={(e) => setUserType(e.value)}
                  sx={{ width: "495px" }}
                  items={memberRoles}
                />
              </div>
            </div>
            <div className=" w-full flex flex-row justify-end gap-2 p-4 border-t-1">
              <SecondaryButton onClick={() => setAddMember(false)}>
                Annuler
              </SecondaryButton>

              <PrimaryButton
                onClick={() => callSendInvite(false)}
                disabled={!email || !name || !userType || loadingAddMember}
              >
                <div className="flex flex-row content-center">
                  <Space x={5} />
                  Inviter
                  <SmallSpinner
                    margin={4}
                    loading={loadingAddMember}
                  ></SmallSpinner>
                </div>
              </PrimaryButton>
            </div>
          </div>
        </Modal1>
        <Modal1 isOpen={marqueOpen} onClose={() => setMarqueOpen(false)}>
          <div className="flex flex-col p-4 rounded-xl bg-white  shadow-md w-fit ">
            {loadingMarque && (
              <div className="flex flex-row text-h3 text-shadow_50 gap-2 items-center  justify-center w-full h-full">
                <SmallSpinner loading={true}></SmallSpinner> Modification des
                dossiers en cours
              </div>
            )}
            {!loadingMarque && (
              <div className="flex flex-col gap-2 max-w-c500  w-c400 ">
                <TextField2T
                  label="Nom de marque"
                  className="w-c400"
                  value={marque}
                  onChange={(e) => setMarque(e.target.value)}
                  transparent={false}
                ></TextField2T>
                {marqueOpen !== true && (
                  <div className="text-h3 font-light text-gray-400">
                    En modifiant le nom de la marque, vous modifiez le nom de la
                    marque pour tous les dossiers affiliés à cette marque.
                  </div>
                )}
                <div className="flex flex-row justify-between">
                  <SecondaryButton
                    onClick={() => {
                      setMarqueOpen(false);
                      setMarque("");
                    }}
                  >
                    Annuler
                  </SecondaryButton>
                  <PrimaryButton
                    className="w-fit  "
                    disabled={marque === ""}
                    onClick={() => handleAddMarque(marqueOpen)}
                  >
                    {marqueOpen !== true
                      ? "  Appliquer à tous les dossiers affiliés"
                      : "Enregistrer"}
                  </PrimaryButton>
                </div>
              </div>
            )}
          </div>
        </Modal1>
        <Modal1 isOpen={bigPhoto} onClose={() => setBigPhoto(null)}>
          <div
            className=" flex flex-col relative bg-white rounded-xl items-center justify-center h-screen w-screen cursor-pointer"
            style={{
              maxHeight: "70vh",
              maxWidth: "70vw",
            }}
            onClick={() => setBigPhoto(null)}
          >
            <img
              src={bigPhoto}
              alt="photo"
              className="rounded-xl w-full h-full object-contain "
            />
            <div className="absolute top-2 right-2 bg-indigo-200 rounded-xl p-4">
              <SecondaryButton onClick={handleChangeLogo}>
                Changer le logo de l'entreprise
              </SecondaryButton>
            </div>
          </div>
        </Modal1>{" "}
        <div className="flex flex-col gap-2 h-fit  w-full pl-4 pb-80 ">
          <div className="text-h1 font-bold text-left  h-fit justify-between flex flex-row w-full">
            Entreprise{" "}
          </div>
          <TabGPT
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></TabGPT>
          {/* Première colonne */}
          {activeTab === "infos" && (
            <div className="flex flex-col gap-2 max-w-c500 pl-4 mt-2">
              <SaveBar
                condition={infos !== orgData.infos}
                onClick={callModifyMaster}
              />

              <div className="mb-4">
                <div className="text-h1 text-left font-medium mt-2 mb-4">
                  Logo entreprise
                </div>

                <div
                  className="rounded-xl border-1 border-shadow_10 h-10 mb-2 w-c100 flex flex-row items-center cursor-pointer"
                  onClick={() => setBigPhoto(orgData.logo)}
                >
                  {orgData.logo && (
                    <img
                      src={orgData.logo}
                      className="h-10 w-auto object-contain rounded-xl"
                    />
                  )}
                </div>
                <SecondaryButton
                  className={"w-fit h-fit"}
                  onClick={() => handleChangeLogo()}
                >
                  Ajouter un logo
                </SecondaryButton>

                <div className="text-h1 font-medium  text-left mb-6 mt-10">
                  Informations de l'entreprise
                </div>
                <div className="flex flex-col gap-1 w-full">
                  <TextField2T
                    className="w-full text-left"
                    label="ID"
                    value={orgData.id}
                    disabled={true}
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Entreprise"
                    value={infos?.entreprise}
                    onChange={(e) =>
                      setInfos({ ...infos, entreprise: e.target.value })
                    }
                  />

                  <TextField2T
                    className="w-full text-left"
                    label="Adresse"
                    value={infos?.adresse}
                    onChange={(e) =>
                      setInfos({ ...infos, adresse: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Code postal"
                    value={infos?.postal}
                    onChange={(e) =>
                      setInfos({ ...infos, postal: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Ville"
                    value={infos?.ville}
                    onChange={(e) =>
                      setInfos({ ...infos, ville: e.target.value })
                    }
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Adresse email de contact"
                    value={infos?.email}
                    onChange={(e) =>
                      setInfos({ ...infos, email: e.target.value })
                    }
                    mandatory={true}
                    type="email"
                  />
                  <TextField2T
                    className="w-full text-left"
                    label="Téléphone de contact"
                    value={infos?.phone}
                    onChange={(e) =>
                      setInfos({ ...infos, phone: e.target.value })
                    }
                    mandatory={true}
                    type="phone"
                  />
                </div>
              </div>
            </div>
          )}
          {/* Deuxième ligne pour les employés */}{" "}
          <div className="flex flex-col gap-2 max-w-c1p2k w-full px-4  mt-4">
            {activeTab === "members" && (
              <div className="w-full">
                <div className="text-h1 font-medium text-left flex flex-row justify-between gap-4 w-full">
                  Membres{" "}
                  {(!orgData.restrictions?.invite_access ||
                    userData.org_admin) && (
                    <PrimaryButton onClick={() => setAddMember(true)}>
                      Ajouter un nouveau membre
                    </PrimaryButton>
                  )}
                </div>
                <Space y={20} />
                <div className="flex flex-col max-w-c1p2k w-full  rounded-lg ">
                  {users
                    .sort((a, b) => {
                      if (a.org_admin === b.org_admin) {
                        if (a.role === b.role) {
                          return (
                            b.tracking?.last_connection?.seconds ||
                            0 - a.tracking?.last_connection?.seconds ||
                            0
                          );
                        }
                        return a.role?.localeCompare(b.role);
                      }

                      return b.org_admin - a.org_admin;
                    })
                    .map((user, index) => (
                      <div key={index}>
                        <NiceMemberBlock
                          last={index === users.length - 1}
                          user={user}
                          userData={userData}
                          orgData={orgData}
                          handleMemberClick={handleMemberClick}
                        ></NiceMemberBlock>
                      </div>
                    ))}
                </div>
              </div>
            )}{" "}
            {activeTab === "marques" && (
              <div className="w-full h-fit  ">
                <div className="w-full h-fit ">
                  <div className="w-full h-fit ">
                    <div className="text-h1 font-medium text-pr flex  flex-row gap-4 ">
                      Marques
                      <SecondaryButton onClick={() => setMarqueOpen(true)}>
                        Ajouter une marque
                      </SecondaryButton>
                    </div>

                    <div className="w-full h-fit mt-4">
                      <div className="w-full h-fit max-w-c700  rounded-lg">
                        {/* Map through users and render ListCell for each */}
                        {marques.map((marque, index) => (
                          <div key={index}>
                            <div className="flex justify-between h-fit items-start flex-row w-full p-2 border-b border-gray-200">
                              <div className="flex flex-row gap-2   items-start">
                                <Icon1 icon_name="flag" size={20} fill="grey" />
                                <div className="text-h2 font-semibold ">
                                  {marque.name}
                                </div>{" "}
                              </div>
                              <div className="flex flex-row gap-1 w-fit">
                                <div className="text-sm min-w-fit bg-indigo-50  text-indigo-400 rounded-full px-2 py-0.5 font-light">
                                  {(saved_data?.folders?.filter(
                                    (f) => f.marque === marque.name
                                  ).length || 0) + " "}
                                  dossiers
                                </div>
                                <SecondaryButton
                                  className="min-w-fit w-fit h-fit"
                                  onClick={() => {
                                    setMarqueOpen(index + 1);
                                    setMarque(marque.name);
                                  }}
                                >
                                  Modifier
                                </SecondaryButton>
                                <SecondaryButton
                                  className="min-w-fit w-fit h-fit"
                                  disabled={
                                    saved_data?.folders?.filter(
                                      (f) => f.marque === marque.name
                                    ).length > 0
                                  }
                                  onClick={() =>
                                    handleRemoveMarque(marque.name)
                                  }
                                >
                                  Supprimer
                                </SecondaryButton>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      {marques.length === 0 && (
                        <div className="h-fit">
                          <div className="flex flex-row gap-3 bg-neutral-200 rounded-xl px-2 py-1 w-fit">
                            <div className="text-h3 font-semibold text-shadow_50">
                              Aucune marque enregistrée
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "signatures" && (
              <div className="w-full h-fit  ">
                <Modal1
                  isOpen={newSignatureOpen}
                  onClose={() => setNewSignatureOpen(false)}
                >
                  <div className="bg-white rounded-xl p-4 h-fit w-c500 flex flex-col gap-2">
                    <div className="text-h2  text-left mb-2">
                      Ajouter une nouvelle signature
                    </div>
                    <DropzoneImage
                      loading={loadingDrop}
                      files={dropped_files}
                      onDrop={onDropZone}
                      onDelete={onDelete}
                    ></DropzoneImage>{" "}
                    <TextField2T
                      label="Nom de la signature"
                      className="w-c400"
                      value={signatureName}
                      onChange={(e) => setSignatureName(e.target.value)}
                      transparent={false}
                      mandatory={true}
                    ></TextField2T>
                    <div className="flex flex-row justify-between mt-4">
                      <SecondaryButton
                        onClick={() => {
                          setNewSignatureOpen(false);
                          setSignatureName("");
                        }}
                      >
                        Annuler
                      </SecondaryButton>
                      <PrimaryButton
                        className="w-fit  "
                        disabled={
                          signatureName === "" || dropped_files.length === 0
                        }
                        onClick={() => handleCreateSignature(false)}
                      >
                        Enregistrer
                      </PrimaryButton>
                    </div>
                  </div>
                </Modal1>
                <Modal1
                  isOpen={newTamponOpen}
                  onClose={() => setNewTamponOpen(false)}
                >
                  <div className="bg-white rounded-xl p-4 h-fit w-c500 flex flex-col gap-2">
                    <div className="text-h2  text-left mb-2">
                      Ajouter un nouveau tampon
                    </div>

                    <DropzoneImage
                      loading={loadingDrop}
                      files={dropped_files}
                      onDrop={onDropZone}
                      onDelete={onDelete}
                    ></DropzoneImage>
                    <TextField2T
                      label="Nom du tampon"
                      className="w-c400"
                      value={signatureName}
                      onChange={(e) => setSignatureName(e.target.value)}
                      transparent={false}
                      mandatory={true}
                    ></TextField2T>
                    <div className="flex flex-row justify-between mt-4">
                      <SecondaryButton
                        onClick={() => {
                          setNewTamponOpen(false);
                          setSignatureName("");
                        }}
                      >
                        Annuler
                      </SecondaryButton>
                      <PrimaryButton
                        className="w-fit  "
                        disabled={
                          signatureName === "" || dropped_files.length === 0
                        }
                        onClick={() => handleCreateSignature(true)}
                      >
                        Enregistrer
                      </PrimaryButton>
                    </div>
                  </div>
                </Modal1>

                <div className="w-full h-fit ">
                  <div className="w-full h-fit ">
                    <div className="text-h1 font-medium text-pr flex  flex-row gap-4 ">
                      Signatures
                      <SecondaryButton
                        onClick={() => setNewSignatureOpen(true)}
                      >
                        Ajouter une signatures
                      </SecondaryButton>
                    </div>

                    <div className="w-full h-fit ">
                      <div className="w-full h-fit mt-4 flex flex-col gap-2">
                        {/* Map through users and render ListCell for each */}
                        {signatures.map((signature, index) => (
                          <div key={index}>
                            <div className="flex justify-between h-fit items-start flex-row bg-neutral-50 border-l-2 border-neutral-200 rounded-xl  p-2  w-c500">
                              <div className="flex flex-row  gap-2 h-fit">
                                {/* User Avatar and Email */}
                                <div className="flex flex-col gap-2 justify-between  w-full items-start">
                                  <div className="text-h2 ">
                                    {signature.name}
                                  </div>
                                  <SecondaryButton
                                    onClick={() =>
                                      handleDeleteSignature(signature)
                                    }
                                    className={"w-fit h-fit"}
                                  >
                                    Supprimer
                                  </SecondaryButton>
                                </div>
                              </div>
                              <div className="flex flex-row gap-2 h-fit ">
                                <div className="flex flex-col  h-fit   rounded-xl">
                                  <div className="border-1 border-shadow_10  bg-neutral-100 h-24 w-40 flex rounded-xl ">
                                    {signature.url && (
                                      <img
                                        src={signature.url}
                                        className="object-contain   w-40  rounded-xl "
                                      ></img>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      {signatures.length === 0 && (
                        <div className="h-fit mt-4">
                          <div className="flex flex-row gap-3 bg-neutral-100 rounded-xl px-2 py-1 w-fit">
                            <div className="text-h3 font-semibold text-shadow_50">
                              Aucune signature enregistrée
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full h-fit mt-10">
                    <div className="text-h1 font-medium text-pr flex  flex-row gap-4 ">
                      Tampons
                      <SecondaryButton onClick={() => setNewTamponOpen(true)}>
                        Ajouter un tampon
                      </SecondaryButton>
                    </div>

                    <div className="w-full h-fit ">
                      <div className="w-full h-fit rounded-lg mt-4 flex flex-col gap-2">
                        {/* Map through users and render ListCell for each */}
                        {tampons.map((tampon, index) => (
                          <div key={index}>
                            <div className="flex justify-between h-fit items-start flex-row w-c500 bg-neutral-50 border-l-2 border-neutral-200 rounded-xl  p-2">
                              <div className="flex flex-row  gap-2 h-fit">
                                {/* User Avatar and Email */}
                                <div className="flex flex-col gap-2 justify-between  w-full items-start">
                                  <div className="text-h2 ">{tampon.name}</div>
                                  <SecondaryButton
                                    onClick={() => handleDeleteTampon(tampon)}
                                    className={"w-fit h-fit"}
                                  >
                                    Supprimer
                                  </SecondaryButton>
                                </div>
                              </div>
                              <div className="flex flex-row gap-2 h-fit ">
                                <div className="flex flex-col  h-fit   rounded-xl">
                                  <div className="border-1 border-shadow_10  bg-neutral-100  h-24 w-40 flex rounded-xl ">
                                    {tampon.url && (
                                      <img
                                        src={tampon.url}
                                        className="object-contain  w-40  rounded-xl "
                                      ></img>
                                    )}
                                  </div>{" "}
                                </div>

                                {/* Close Icon (Removable functionality) */}
                              </div>{" "}
                            </div>
                          </div>
                        ))}
                      </div>
                      {tampons.length === 0 && (
                        <div className="h-fit mt-4">
                          <div className="flex flex-row gap-3 bg-neutral-100 rounded-xl px-2 py-1 w-fit">
                            <div className="text-h3 font-semibold text-shadow_50">
                              Aucune tampon enregistré
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "notifications" && (
              <div className="flex flex-col gap-2 max-w-c500">
                <div className="text-h1 font-medium text-left mb-2">
                  Notifications
                </div>

                <ToggleSettingsBrick
                  title="Notifications push"
                  description="Envoyer des notifications push aux utilisateurs assignés lors de la création d'une tâche."
                  checked={appState.notifications !== false}
                  onChange={(checked) => {
                    setAppState((prev) => ({
                      ...prev,
                      notifications: checked,
                    }));
                  }}
                />

                {!userData.org_admin && (
                  <>
                    <div className="text-h3 text-shadow_50 font-bold">
                      Seul un administrateur peut accéder à cette partie.
                    </div>
                  </>
                )}
                {userData.org_admin && (
                  <>
                    <div className="text-h3 text-shadow_50 font-normal items-center flex flex-row gap-2">
                      Seulement vous et les autres administrateurs pouvez
                      accéder à cette partie. Vous pouvez configurer les
                      notifications emails qui seront envoyées aux emails
                      définis.
                    </div>

                    <SaveBar
                      condition={notifications !== orgData.notifications}
                      onClick={handleSaveNotifications}
                    />

                    <div className="flex p-2 border-1 rounded-lg flex-col gap-2 my-4">
                      <div className="text-h3  ">
                        Emails définis pour recevoir les notifications de
                        hexagone
                      </div>
                      {notifications?.emails?.map((email, index) => (
                        <div
                          key={index}
                          className="flex flex-row gap-2 items-center border-l-"
                        >
                          <div className="text-h3   bg-indigo-50 rounded-md px-2 py-1 text-indigo-500">
                            {email}
                          </div>
                          <SecondaryButton
                            onClick={() => {
                              setNotifications({
                                ...notifications,
                                emails: notifications.emails.filter(
                                  (e) => e !== email
                                ),
                              });
                            }}
                          >
                            <Icon1 icon_name="delete" size={15}></Icon1>
                          </SecondaryButton>
                        </div>
                      ))}

                      <div className="flex flex-row gap-2 items-center border-l-">
                        <TextField2T
                          value={new_email}
                          onChange={(e) => setNewEmail(e.target.value)}
                          label={"Ajouter un email"}
                          type="email"
                          className="w-c200"
                        ></TextField2T>

                        <SecondaryButton
                          onClick={() => {
                            setNotifications({
                              ...notifications,
                              emails: notifications?.emails
                                ? [...notifications?.emails, new_email]
                                : [new_email],
                            });
                            setNewEmail("");
                          }}
                          disabled={!new_email || !new_email.includes("@")}
                          className="w-fit h-fit"
                        >
                          Ajouter cet email
                        </SecondaryButton>
                      </div>
                    </div>

                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque nouvelle demande"
                      description={
                        "   Recevoir un email à chaque nouveau dossier créé depuis hexagone par un client."
                      }
                      checked={notifications?.email_new_demand_client}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_new_demand_client: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque nouveau devis"
                      description={
                        "   Recevoir un email à chaque nouveau devis créé depuis hexagone par un client."
                      }
                      checked={notifications?.email_new_devis_client}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_new_devis_client: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque devis créé depuis mon site web"
                      description={
                        "   Recevoir un email à chaque nouveau devis créé depuis mon site web."
                      }
                      checked={notifications?.email_new_devis_website}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_new_devis_website: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque devis signé"
                      description={
                        "   Recevoir un email à chaque nouveau devis signé."
                      }
                      checked={notifications?.email_devis_signed}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_devis_signed: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>

                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque nouveau message"
                      description={
                        "   Recevoir un email à chaque nouveau message envoyé depuis hexagone par un client."
                      }
                      checked={notifications?.email_new_chat_message}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_new_chat_message: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <Space y={10} />
                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque nouveau paiement"
                      description={
                        "   Recevoir un email à chaque paiement effectué sur hexagone par un particulier."
                      }
                      checked={notifications?.email_new_successful_payment}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_new_successful_payment: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <ToggleSettingsBrick
                      title="Recevoir un email à chaque nouvelle demande de rdv"
                      description={
                        "Recevoir un email à chaque nouvelle demande de rendez-vous par un client sur hexagone"
                      }
                      checked={notifications?.email_new_rdv_demand}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_new_rdv_demand: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>

                    <ToggleSettingsBrick
                      title="Recevoir une copie des signature de devis"
                      description={
                        "   Recevoir une email à chaque nouvelle demande de signature de devis envoyés par un partenaire."
                      }
                      checked={notifications?.auto_add_cc_invoice_sign}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          auto_add_cc_invoice_sign: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <ToggleSettingsBrick
                      title="Recevoir une copie des emails envoyés par les clients"
                      description={
                        "Recevoir un email à chaque nouvelle demande de xml envoyé par un partenaire sur hexagone"
                      }
                      checked={notifications?.email_xml_requested}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_xml_requested: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                    <ToggleSettingsBrick
                      title="Recevoir un email lorsqu'un partenaire est supprimé"
                      description={
                        "   Recevoir un email lorsqu'un partenaire est supprimé parmi vos clients et bureaux d'étude"
                      }
                      checked={notifications?.email_partner_deleted}
                      onChange={(checked) => {
                        setNotifications({
                          ...notifications,
                          email_partner_deleted: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                  </>
                )}
              </div>
            )}
            {activeTab === "sync_emails" && (
              <div className="flex flex-col gap-2 max-w-c500">
                <div className="text-h1 font-medium text-left mb-2">
                  Sync Emails
                </div>
                <div className="text-h3 text-shadow_50 font-normal">
                  Gérez les emails de synchronisation pour votre organisation.
                </div>

                <div className="flex p-2 border-1 rounded-lg flex-col gap-2 my-4">
                  <div className="text-h3">
                    Emails de synchronisation configurés
                  </div>

                  {syncEmails && syncEmails.length > 0 ? (
                    syncEmails.map((email, index) => (
                      <div
                        key={index}
                        className="flex flex-row gap-2 items-center"
                      >
                        <div className="text-h3 bg-indigo-50 rounded-md px-2 py-1 text-indigo-500">
                          {email}
                        </div>
                        <SecondaryButton
                          onClick={() => handleRemoveSyncEmail(email)}
                          className="w-fit h-fit"
                        >
                          <Icon1 icon_name="delete" size={15}></Icon1>
                        </SecondaryButton>
                      </div>
                    ))
                  ) : (
                    <div className="text-h3 font-light text-gray-400">
                      Aucun email de synchronisation configuré
                    </div>
                  )}

                  <div className="flex flex-row gap-2 items-center mt-2">
                    <TextField2T
                      value={newSyncEmail}
                      onChange={(e) => setNewSyncEmail(e.target.value)}
                      label={"Ajouter un email"}
                      type="email"
                      className="w-c200"
                      placeholder="example@domain.com"
                    />
                    <SecondaryButton
                      onClick={handleAddSyncEmail}
                      disabled={!newSyncEmail || !newSyncEmail.includes("@")}
                      className="w-fit h-fit"
                    >
                      Ajouter
                    </SecondaryButton>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "access" && (
              <div className="flex flex-col gap-2 max-w-c500">
                <div className="text-h1 font-medium text-left mb-2">
                  Restrictions d'accès
                </div>

                <SaveBar
                  condition={restrictions !== orgData.restrictions}
                  onClick={handleSaveRestrictions}
                />
                {!userData.org_admin && (
                  <>
                    <div className="text-h3 text-shadow_50 font-bold">
                      Seul un administrateur peut accéder à cette partie.
                    </div>
                  </>
                )}
                {userData.org_admin && (
                  <>
                    <div className="text-h3 text-shadow_50 font-normal items-center flex flex-row gap-2">
                      Seulement vous et les autres administrateurs pouvez
                      accéder à cette partie. Vous pouvez resteindre l'accès à
                      certaines parties de hexagone en fonction des rôles.
                    </div>
                    <Space y={10} />
                    <ToggleSettingsBrick
                      title="Limiter l'accès aux paramètres"
                      description={
                        "  Seuls les administrateurs peuvent accéder aux paramètres de l'organisation."
                      }
                      checked={restrictions?.settings_access}
                      onChange={(checked) => {
                        setRestrictions({
                          ...restrictions,
                          settings_access: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>

                    <ToggleSettingsBrick
                      title="Limiter l'invitation de nouveaux membres"
                      description={
                        "  Seuls les administrateurs peuvent inviter de nouveaux  membres."
                      }
                      checked={restrictions?.invite_access}
                      onChange={(checked) => {
                        setRestrictions({
                          ...restrictions,
                          invite_access: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                  </>
                )}
                {userData.org_admin && workspaceData && (
                  <>
                    <ToggleSettingsBrick
                      title="Limiter la vision des conducteurs"
                      description={
                        "    Les conducteurs ne voient que leurs dossiers assignés."
                      }
                      checked={restrictions?.conductor_limited}
                      onChange={(checked) => {
                        setRestrictions({
                          ...restrictions,
                          conductor_limited: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                  </>
                )}
                {userData.org_admin && !workspaceData && (
                  <>
                    <ToggleSettingsBrick
                      title="Limiter la vision des opérateurs"
                      description={
                        "     Les opérateurs ne voient que leurs dossiers assignés."
                      }
                      checked={restrictions?.operator_limited}
                      onChange={(checked) => {
                        setRestrictions({
                          ...restrictions,
                          operator_limited: checked,
                        });
                      }}
                    ></ToggleSettingsBrick>
                  </>
                )}
              </div>
            )}
          </div>{" "}
        </div>
      </div>{" "}
    </div>
  );
};
export default Organisation;

export const NiceMemberBlock = ({
  last = false,
  user,
  handleMemberClick,
  orgData,
  userData,

  setMemberOpen,
  canopen,
  show_id,
  disabled = false,
}) => {
  return (
    <div className={`flex flex-col p-2  w-full ${last ? " " : ""}`}>
      <div className="flex w-full flex-col ">
        <div className="flex flex-row gap-2 w-full items-center">
          <div className="relative">
            <img
              src={
                user.photo ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR2dtSs0-ybB7OnCnfsC1UWgViGQLxAtVx83IPHmxIjh1istqxGhm2sjWOSF1TDN_J-r0&usqp=CAU"
              }
              alt="photo"
              className="min-h-10 min-w-10 h-10 w-10 rounded-full"
            />
            <div
              className="absolute -bottom-1 -right-0 bg-white p-0.5
        rounded-full flex items-center justify-center"
            >
              <Icon1
                icon_name={user.org_admin ? "settings-filled" : ""}
                size={11}
                fill={user.org_admin ? "black" : "grey"}
              />
            </div>
          </div>
          <div className="w-full flex items-center">
            {/* Limiter la largeur du nom pour aligner les emails */}
            <div className="flex w-full max-w-c300 flex-col px-1">
              <div className="flex-1 font-medium text-h2   truncate">
                {user.display_name}
              </div>
              {/* Centrer l'email dans son div */}
              <div className="flex-1  text-h3 font-normal text-left">
                {user.email}
              </div>
              {show_id && (
                <div className="flex-1  text-h3 font-normal text-left">
                  {user.id}
                </div>
              )}
            </div>
            <div className=" w-c250 ">
              <div
                className={`rounded-xl   w-fit  px-2 py-0.5 text-h3 text-shadow_50`}
              >
                {getRoleString(user?.role)}
              </div>
            </div>
            {/* Centrer l'email dans son div */}
            <Tippy
              content="Dernière connexion"
              className="custom-tooltip"
              placement="top"
              delay={500}
            >
              <div className="w-c150 text-h3 font-normal text-left">
                {user.tracking?.last_connection ? (
                  new Date(
                    user.tracking?.last_connection?.seconds * 1000
                  ).toLocaleString()
                ) : (
                  <span className="text-neutral-300">Jamais connecté</span>
                )}
              </div>
            </Tippy>
            {userData && (
              <Tippy
                content="Modifier la couleur"
                className="custom-tooltip"
                placement="top"
                delay={500}
              >
                <div className="ml-auto">
                  <div
                    onClick={() => handleMemberClick(user.id, false)}
                    className={` rounded-md w-5 h-5 border-1 border-indigo-500 hover:scale-110 duration-150 transition-all cursor-pointer`}
                    style={{
                      backgroundColor: user.color
                        ? flutterColorToHex(user.color)
                        : "transparent",
                    }}
                  />
                </div>
              </Tippy>
            )}

            {(canopen || userData?.org_admin) && !disabled && (
              <div className="ml-4">
                <SecondaryButton
                  onClick={() =>
                    (setMemberOpen && setMemberOpen(user.id)) ||
                    (handleMemberClick && handleMemberClick(user.id, true))
                  }
                >
                  Modifier
                </SecondaryButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
